export const FETCH_COUNTRIES = 'FETCH_COUNTRIES';
export const FETCH_COUNTRIES_FAIL = 'FETCH_COUNTRIES_FAIL';
export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS';

export const FILTER_REGION = 'FILTER_REGION';

export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';

export const SEARCH_COUNTRIES = 'SEARCH_COUNTRIES';
export const SEARCH_COUNTRIES_FAIL = 'SEARCH_COUNTRIES_FAIL';
export const SEARCH_COUNTRIES_SUCCESS = 'SEARCH_COUNTRIES_SUCCESS';

export const SELECT_COUNTRY = 'SELECT_COUNTRY';

export const FETCH_COUNTRY = 'FETCH_COUNTRY';
export const FETCH_COUNTRY_FAIL = 'FETCH_COUNTRY_FAIL';
export const FETCH_COUNTRY_SUCCESS = 'FETCH_COUNTRY_SUCCESS';

export const SELECT_COUNTRIES = 'SELECT_COUNTRIES';

export const FETCH_BORDER_COUNTRIES = 'FETCH_BORDER_COUNTRIES';
export const FETCH_BORDER_COUNTRIES_FAIL = 'FETCH_BORDER_COUNTRIES_FAIL';
export const FETCH_BORDER_COUNTRIES_SUCCESS = 'FETCH_BORDER_COUNTRIES_SUCCESS';

export const DISPLAY_COUNTRY = 'DISPLAY_COUNTRY';
export const LOADING_COUNTRIES = 'LOADING_COUNTRIES';
